import { get, post, put } from './client';

export const login = (data) => post('/api/auth/login', data);

export const getMe = () => get('/api/auth/me');

export const updateMe = (data) => put('/api/auth/me', data);
